module.exports = __webpack_public_path__ + "static/media/eye.bcdde8b0.svg";